import React, { useState } from "react";
import { Link } from "react-router-dom";
import loginbanner from "../assets/images/login-banner.png";
import logo from "../assets/logo/Logo.png";
import google from "../assets/logo/google.png";
import facebook from "../assets/logo/facebook.png";
import apple from "../assets/logo/apple.png";
import eye from "../assets/images/eye.png";
import eyeslash from "../assets/images/eye-slash.png";

export default function Auth() {
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    console.log("Login Data:", { email, password });
  };

  const handleForgotPasswordSubmit = (e) => {
    e.preventDefault();
    console.log("Reset Password Email:", email);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Side Image */}
      <div className="hidden lg:block lg:w-1/2">
        <img src={loginbanner} alt="Decorative" className="object-cover w-full h-full" />
      </div>

      {/* Right Side */}
      <div className="w-full lg:w-1/2 px-6 flex flex-col">
        <div className="flex justify-end pt-8">
          <button className="flex items-center text-sm text-gray-600 hover:text-gray-900">
            English
            <svg className="ml-1 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center max-w-[440px] mx-auto w-full">
          <img src={logo} alt="Pipaan Logo" className="w-40 mb-6" />

          {/* Toggle between Login and Forgot Password */}
          {!isForgotPassword ? (
            <>
              {/* Login Form */}
              <form onSubmit={handleLoginSubmit} className="w-full space-y-6">
                <h1 className="text-2xl font-semibold text-center">Login Your Account</h1>

                <div className="space-y-4">
                  <div className="flex flex-col space-y-2">
                    <label className="text-sm font-medium" htmlFor="email">
                      Email
                    </label>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your Email"
                      className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div className="flex flex-col space-y-2 relative">
                    <label className="text-sm font-medium" htmlFor="password">
                      Password
                    </label>
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-10 transform -translate-y-1/2"
                    >
                      <img src={showPassword ? eye : eyeslash} alt="Toggle Password" className="w-6 h-6" />
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <input type="checkbox" id="remember" className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                    <label htmlFor="remember" className="text-sm font-medium leading-none">
                      Remember Me
                    </label>
                  </div>
                  <button
                    type="button"
                    onClick={() => setIsForgotPassword(true)}
                    className="text-sm text-[#006838] hover:underline"
                  >
                    Forgot Password?
                  </button>
                </div>

                <button type="submit" className="w-full h-12 bg-[#1B2537] text-white rounded-lg font-medium">
                  Sign in
                </button>

                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-white px-2 text-gray-500">Or continue with</span>
                  </div>
                </div>

                <div className="flex justify-center space-x-4">
                  <img src={google} alt="Google" className="w-10 cursor-pointer" />
                  <img src={facebook} alt="Facebook" className="w-10 cursor-pointer" />
                  <img src={apple} alt="Apple" className="w-10 cursor-pointer" />
                </div>

                <p className="text-center text-sm text-gray-600">
                  Don't have an account? <Link to="/signup" className="text-[#006838] hover:underline font-medium">Create New Account</Link>
                </p>
              </form>
            </>
          ) : (
            <>
              {/* Forgot Password Form */}
              <button onClick={() => setIsForgotPassword(false)} className="text-gray-500 text-sm flex items-center mb-4">
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"></path>
                </svg>
                Back to login
              </button>

              <h1 className="text-2xl font-semibold text-center mb-4">Forgot Your Password?</h1>

              <form onSubmit={handleForgotPasswordSubmit} className="w-full space-y-4">
                <div>
                  <label className="text-sm font-medium block mb-1">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your Email"
                    className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <button type="submit" className="w-full h-12 bg-[#1B2537] text-white rounded-lg font-medium">
                  Submit
                </button>
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-white px-2 text-gray-500">Or login with</span>
                  </div>
                </div>

                <div className="flex justify-center space-x-4">
                  <img src={google} alt="Google" className="w-10 cursor-pointer" />
                  <img src={facebook} alt="Facebook" className="w-10 cursor-pointer" />
                  <img src={apple} alt="Apple" className="w-10 cursor-pointer" />
                </div>
                <p className="text-center text-sm text-gray-600">
                  Don't have an account? <Link to="/signup" className="text-[#006838] hover:underline font-medium">Create New Account</Link>
                </p>
              </form>
            </>
          )}
        </div>

        <div className="py-6 text-center text-sm text-gray-600">© 2025 Pipaan. All Rights Reserved</div>
      </div>
    </div>
  );
}
